<template>
  <div class="jbrowse">
    <div class="jbrowse-inner">
      <div>JBrowse</div>
      <div></div>
      <div style="width: 1200px; margin: 20px auto;">
        <el-form ref="form1" class="efp_form" :inline="true" :model="Eplant_form">
          <el-form-item label="Species">
            <el-select size="large" v-model="Eplant_form.species" @change="SpeciesChange" placeholder="Choose">
              <el-option v-for="(item, index) in firstSpeciesOptions" :key="index" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <iframe :src="JBrowse_url" style="border: 1px solid black" width="100%" height="700px">
        </iframe>
      </div>
    </div>
  </div>
</template>

<script>
let url = {
  specie_all: "species/specie_jbrowse_name"
};
import axios from 'axios';
export default {
  created() {
    this.specie_all()
    let baseURL = axios.defaults.baseURL.replace('/api', '')
    if (this.data) {
      this.JBrowse_url = `${baseURL}/jb/?data=All_json/` + this.data + '&loc=' + this.chromesome + ':' + this.start + '..' + this.end
    } else {
      this.JBrowse_url = `${baseURL}/jb/?data=All_json/Arabidopsis_thaliana`
    }
  },
  data: function () {
    return {
      Eplant_form: {
        species: this.$route.query.data || 'Arabidopsis_thaliana'
      },
      data: this.$route.query.data,
      chromesome: this.$route.query.chromesome,
      start: this.$route.query.start,
      end: this.$route.query.end,
      JBrowse_url: '',
      firstSpeciesOptions: []
    };
  },
  methods: {
    SpeciesChange(val) {
      let baseURL = axios.defaults.baseURL.replace('/api', '')
      this.JBrowse_url = `${baseURL}/jb/?data=All_json/${val}`
    },
    specie_all() {
      this.http.get(url.specie_all, {}).then((res) => {
        if (res.data.code == 200) {
          this.firstSpeciesOptions = res.data.data;
        }
      }).catch((err) => {
        this.$message.warning(err.data.msg);
      });
    }
  }
};
</script>

<style scoped>
.jbrowse {
  width: 100%;
  padding: 30px 0px;
  background: #f5f9fc;
}
.jbrowse .jbrowse-inner {
  width: 1240px;
  height: auto;
  padding: 0px 20px;
  padding-bottom: 20px;
  margin: 0 auto;
  background: rgba(255, 255, 255, 1);
}

.jbrowse .jbrowse-inner div:first-child {
  height: 50px;
  font-size: 30px;
  font-family: PingFang SC;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
  line-height: 50px;
}
.jbrowse .jbrowse-inner div:nth-child(2) {
  width: 100%;
  height: 1px;
  background: rgba(229, 233, 235, 1);
}
.efp_form >>> .el-form-item__label {
  /* width:100px; */
  height: 40px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #333;
  line-height: 40px;
}
</style>
